import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";

const ServiceList = [
  {
    icon: <FiCast />,
    title: "Applications mobile",
    description:
      "Développement de votre application mobile sur mesure Android et IOS",
  },
  {
    icon: <FiMonitor />,
    title: "Applications web",
    description:
      "Sites internet, plateformes sur mesure, éco-systèmes digitaux, CMS, ...",
  },
  {
    icon: <FiUsers />,
    title: "Hébergement & Support",
    description:
      "Nous serons en mesure de vous proposer différentes solutions d’hébergement en fonction de vos besoins.",
  },
  {
    icon: <FiLayers />,
    title: "Autre",
    description:
      "Pour toutes questions, projets ou demandes d'informations, contactez-nous !",
  },
];

class ServiceTwo extends Component {
  render() {
    let title = "Services",
      description =
        "Nous intervenons sur de nombreux domaines. De l’audit à l’opérationnel, nous accompagnons nos clients dans l’ensemble de leurs problématiques.";
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-4 col-12">
            <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
              <h2 className="title">{title}</h2>
              <p>{description}</p>
              <div className="service-btn">
                <a className="btn-transparent rn-btn-dark" href="/contact">
                  <span className="text">Contactez-nous</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-12 mt_md--50">
            <div className="row service-one-wrapper">
              {ServiceList.map((val, i) => (
                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                  <a href="javascript:void(0)" style={{ cursor: "default" }}>
                    <div className="service service__style--2">
                      <div className="icon">{val.icon}</div>
                      <div className="content">
                        <h3 className="title">{val.title}</h3>
                        <p>{val.description}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceTwo;
